import { cardPreviewContext } from '@context/card-preview-context';
import type { PropsWithChildren } from 'react';

interface CardPreviewContextProviderProps {
  hideEmptyAttributes?: boolean | undefined;
}

export const CardPreviewContextProvider = ({
  hideEmptyAttributes = false,
  children,
}: PropsWithChildren<CardPreviewContextProviderProps>) => {
  return (
    <cardPreviewContext.Provider value={{ hideEmptyAttributes }}>{children}</cardPreviewContext.Provider>
  );
};
